<template>
  <div id="cat" v-cloak>
    <div class="vx-row">
      <div class="vx-col w-full mb-base">
        <ReferenceDocument
          :show="showReferenceDocument"
          @finish="onfinish"
          :partyid="partyid"
          :showReferenceDocument="showReferenceDocument"
          :reasonIdCurrent="reasonIdCurrent"
        ></ReferenceDocument>
        <data-grid
          ref="grid"
          stripe
          :data-source="gridDataSource"
          :search-data="gridSearchData"
          :columns="[
            { title: 'حساب', sort: 'accountId' },
            { title: 'مقدار', sort: 'amount' },
            { title: 'تاریخ ایجاد', sort: 'createOn' },
            { title: 'کاربر ایجادکننده', sort: 'creatorUserId' },
            { title: 'نوع تراکنش مالی', sort: 'financialTransactionQueryType' },
            { title: $t('شناسه مرجع'), sort: 'reasonId' },
            { title: $t('Action'), sort: 'Action' },
          ]"
        >
          <template slot-scope="{ row }">
            <td style="width: 13%">
              {{ row.accountId }}
            </td>
            <td style="width: 13%">
              <!-- {{ row.amount}} -->
              {{ Number(row.amount).toLocaleString() }}
            </td>
            <td style="width: 13%; direction: ltr">
              {{ row.createOn.split(" ")[0] }}<br />{{
                row.createOn.split(" ")[1]
              }}
            </td>
            <td style="width: 13%">
              {{ row.creatorUserId }}
            </td>
            <td style="width: 13%">
              <span v-if="row.financialTransactionQueryType == '2'">
                برداشت
              </span>
              <span v-if="row.financialTransactionQueryType == '1'">
                واریز
              </span>
            </td>
            <td style="width: 13%">
              {{ row.reasonId }}
            </td>
            <td style="width: 13%">
              <vs-button
                color="primary"
                type="border"
                icon-pack="feather"
                icon="icon-edit"
                class="bordered-btn"
                @click.prevent="onShowReferenceDocument(row)"
              >
                سند مرجع
              </vs-button>
            </td>
          </template>
        </data-grid>
      </div>
    </div>
  </div>
</template>

<script>
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";
import vSelect from "vue-select";
import ReferenceDocument from "./ReferenceDocument.vue";
export default {
  components: {
    ReferenceDocument,
    DataGrid,
    "v-select": vSelect,
  },
  props: {
    promoter: {},
  },
  data() {
    return {
      showReferenceDocument: false,
      reasonIdCurrent: "",
      customers: [
        { name: "برداشت و واریز", id: 0 },
        { name: "برداشت", id: 2 },
        { name: "واریز", id: 1 },
      ],
      PartyId: 0,
      gridDataSource: {
        type: "app",
        service: "Credits/api/FinancialTransactionQuery",
      },
      gridSearchData: {
        OwnerUserId: this.$route.params.id,
      },
    };
  },
  methods: {
    onfinish() {
      this.showReferenceDocument = false;
    },
    onShowReferenceDocument(row) {
      this.reasonIdCurrent = row.reasonId;
      this.showReferenceDocument = true;
    },
  },
};
</script>
<style scoped>
#reset-btn {
  margin-left: 1.5rem;
  background: #3ec9d6 !important;
}
</style>
<style lang="scss">
input[type="checkbox"] {
  -ms-transform: scale(2); /* IE */
  -moz-transform: scale(2); /* FF */
  -webkit-transform: scale(2); /* Safari and Chrome */
  -o-transform: scale(2); /* Opera */
  transform: scale(2);
  padding: 10px;
}
.checkboxtext {
  font-size: 1vw;
  font-weight: bold;
  display: inline;
}
</style>
